module.exports = __webpack_public_path__ + "img/65.7ca04294.jpg";